<template>
  <section class="listing">
    <div class="header">
      <div class="title">Cortesias/Testes</div>
      <button @click="ticket = 'new'" class="button-save"><i class="fas fa-plus"></i><span>NOVA</span></button>
    </div>
    <!-- <form @submit.prevent class="form form-search">
      <input v-model="iniDate" @change="getData" type="date" />
      <input v-model="endDate" @change="getData" type="date" />
      <input v-model="search" type="text" placeholder="Pesquisar..." />
    </form> -->
    <div class="print-header">
      <div class="print-title">Cortesias</div>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <div v-for="(t, i) in filtered" :key="i" class="list">
          <!--<div v-if="i > 0 ? getDay(t.date) !== getDay(filtered[i - 1].date) : true" class="calendar">
            <span>{{ getDay(t.date) }}</span>
            <span>{{ getMonthText(t.date) }}</span>
          </div>
          <div v-if="i > 0 ? getDay(t.date) === getDay(filtered[i - 1].date) : false" style="width: 50px"></div>
          <div class="time-text">
            <span>{{ getHours(t.date) }}</span>
            <span>{{ getMinutes(t.date) }}</span>
          </div> -->
          <div class="data">
            <div class="main-data">{{ t.name }}</div>
            <div class="detail-data">Profit: {{ t.profit ? t.profit : 'Não Ativado' }}</div>
            <div class="detail-data">BlackArrow: {{ t.black ? t.black : 'Não Ativado' }}</div>
            <div class="detail-data">NinjaTrader: {{ t.ninja ? t.ninja : 'Não Ativado' }}</div>
            <div class="detail-data">NinjaBotYan: {{ t.ninjaBotYan ? t.ninjaBotYan : 'Não Ativado' }}</div>
            <div class="detail-data">ProfitBotYan: {{ t.profitBotYan ? t.profitBotYan : 'Não Ativado' }}</div>
            <div class="detail-data">BlackArrowBotYan: {{ t.blackBotYan ? t.blackBotYan : 'Não Ativado' }}</div>

          </div>
          <div class="actions" style="min-width: 50px; margin-left: 20px;">
            <div class="actions">
              <!-- <button  @click="remove(p.id)" class="button-action" style="margin-right: 5px"><i class="fas fa-trash-alt"></i><span>EXCLUIR</span></button> -->
              <button @click="$router.push(`/courtesy/${t.id}`)" class="button-action"><i class="fas fa-pen"></i><span>ALTERAR</span></button>
            </div>
            <!-- <button @click="cancel(t.id)" class="button-action">
              <i class="fas fa-undo"></i><span>CANCELAR</span>
            </button> -->
          </div>
        </div>
      </div>
    </transition>
    <Courtesy v-if="ticket" :ticket="ticket" :ticketData="ticketData" :close= "() => {
      this.ticket = null
      this.getData()
    }"/>
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll, cancel } from '../api/courtesy'
import Courtesy from './Courtesy.vue'

export default {
  components: { Courtesy },
  data () {
    return {
      loading: true,
      tickets: [],
      iniDate: null,
      endDate: null,
      search: '',
      ticket: null,
      ticketData: null
    }
  },
  computed: {
    filtered () {
      return this.tickets.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {
    async '$route' (value) {
      this.ticket = value.params['id'] || null
      // Update list
      if (!value.params['id']) {
        this.getData()
      } else {
        this.ticketData = this.tickets.find(x => x.id === Number(value.params['id']))
      }
    },
    ticket (value) {
      if (!value) this.getData()
    }
  },
  async mounted () {
    try {
      const date = new Date()
      this.endDate = date.toISOString().split('T')[0]
      date.setDate(date.getDate() - 30)
      this.iniDate = date.toISOString().split('T')[0]
      this.getData()
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        const tickets = await getAll()
        this.tickets = tickets || []
      } catch (error) {
        logger.error(error)
      }
      this.loading = false
    },
    async cancel (id) {
      this.loading = true
      try {
        await cancel(id)
        this.getData()
      } catch (error) {
        logger.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.list {
  border: 1px solid #918f8f;
}
.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  margin-right: 10px;
  color: #555;
  display: flex;
  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

.form-search {
  display: flex;
  flex-direction: row;
  padding: 0;
  padding-bottom: 10px;

  input {
    flex: 1;
    margin: 0 5px;
  }
}

.button-action:hover {
  i {
    animation-name: ticket-image !important;
    animation-duration: 0.5s !important;
    animation-iteration-count: 1 !important;
  }
}

.button-save {
  color: #fff;
  border: none;
  border-radius: 100px;
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 7px;
  }
}

.print-header {
  display: none;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid $primary-color;
  padding: 20px 15px;
  margin-bottom: 20px !important;
}

.print-title {
  font-size: 2em;
  color: $primary-color;
  font-weight: 500;
}

@media print {
  .admin-router {
    margin: 0;
  }
  .print-header {
    display: block;
  }
  .header, .form-search {
    display: none !important;
  }
  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }
  .list {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
